<script>
    import { ContentLoader } from "vue-content-loader"

    export default {
        components: { ContentLoader }
    }
</script>

<template>
    <content-loader
        :width="375"
        :height="668"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
    >
        <rect x="0" y="1" rx="0" ry="0" width="375" height="211" />
        <rect x="15" y="228" rx="0" ry="0" width="345" height="26" />
        <rect x="15" y="266" rx="0" ry="0" width="102" height="23" />
        <rect x="16" y="304" rx="0" ry="0" width="341" height="54" />
        <rect x="67" y="398" rx="0" ry="0" width="57" height="20" />
        <rect x="223" y="395" rx="0" ry="0" width="61" height="16" />
        <rect x="17" y="469" rx="0" ry="0" width="109" height="13" />
        <rect x="331" y="473" rx="0" ry="0" width="27" height="10" />
        <rect x="15" y="438" rx="0" ry="0" width="345" height="18" />
        <rect x="19" y="541" rx="0" ry="0" width="109" height="13" />
        <rect x="333" y="545" rx="0" ry="0" width="27" height="10" />
        <rect x="17" y="510" rx="0" ry="0" width="345" height="18" />
        <rect x="22" y="718" rx="0" ry="0" width="109" height="13" />
        <rect x="336" y="722" rx="0" ry="0" width="27" height="10" />
        <rect x="20" y="687" rx="0" ry="0" width="345" height="18" />
        <rect x="21" y="605" rx="0" ry="0" width="109" height="13" />
        <rect x="335" y="609" rx="0" ry="0" width="27" height="10" />
    </content-loader>
</template>


// WEBPACK FOOTER //
// src/skeleton/columnSkeleton.vue